import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import { isPaidPlan } from '@/constants/userSubscriptionPlans'
import { useAuth } from '@/hooks'

export const useCanToggle = () => {
  const auth = useAuth()
  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const owner = useSelector(
    migrationProjectSelector.getIsCurrentUserOwnerOfProject
  )

  const projectTeam = useSelector(migrationProjectSelector.getProjectTeam)

  const inTeam = projectTeam && auth.teams.some((t) => t.id === projectTeam.id)

  const ownerPlan = useSelector(migrationProjectSelector.getProjectOwnerPlan)

  // Every paid plan gets guest comments (OCT-5395); only Free is sold Pro.
  const badge = !inTeam && owner && !isPaidPlan(ownerPlan)

  const disabled = !inTeam && !owner && canEdit

  return { badge, disabled }
}
